import { createSlice } from "@reduxjs/toolkit";
const initialState = {
	user: false,
	isLoading: false,
	token: "",
  isLoggedIn: false,
  permissions: [],
  rolesListing : [],
  objectListing: []
};

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    loginSuccess(state, action) {
      state.user = action.payload;
      state.token = action.payload.accessToken;
      state.isLoggedIn = !!action.payload.accessToken;
      state.permissions = action.payload.permissions;
    },
    IsLoading(state, action) {
      state.isLoading = action.data;
    },
    logout(state){
      state.user = "";
      state.token = "";
    },
    rolesListing(state, action){
      state.rolesListing = action.payload;
    },
    objectListing(state, action){
      state.objectListing = action.payload;
    }
  }
});
export const userActions = userSlice.actions;
export default userSlice;
